
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/rEditor/rootComps/newReleasesFeed/newReleasesFeed.scss.css.virtualfile';
        module.exports = {"container":"_container_1an6l_7"};